'use client'

import { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { useAssistant } from '@/lib/assistantContext';

export default function AssistantFAB() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const { openPanel } = useAssistant();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 100) {
        setIsVisible(currentScrollY < lastScrollY);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <button
      onClick={openPanel}
      className={`md:hidden fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full 
        bg-[#F5CC5C] hover:bg-[#e6bd4d] shadow-[0_4px_12px_rgba(0,0,0,0.2)]
        flex items-center justify-center transition-opacity duration-150
        ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      aria-label="Open Assistant"
    >
      <Sparkles className="w-6 h-6 text-[#103065] animate-slow-rotate" />
    </button>
  );
}
